export const ACCEPTED_CHAT_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif'
];

export const ACCEPTED_CHAT_FILE_EXTENSIONS = [
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'txt',
  'md',
  'rtf',
  'csv',
  'html',
  'htm',
  'css',
  'js',
  'ts',
  'tsx',
  'jsx',
  'json',
  'xml',
  'py',
  'cs',
  'java',
  'c',
  'cpp',
  'h',
  'hpp',
  'go',
  'rb',
  'php',
  'sh',
  'yml',
  'yaml',
  'sql',
  'tex'
];

export const ACCEPTED_CHAT_FILE_ACCEPT = [
  ...ACCEPTED_CHAT_IMAGE_TYPES,
  ...ACCEPTED_CHAT_FILE_EXTENSIONS.map((ext) => `.${ext}`)
].join(',');

const IMAGE_URL_EXT = /\.(jpe?g|png|webp|gif)$/i;

export const getFileExtension = (name = '') => {
  const index = String(name).lastIndexOf('.');
  return index >= 0 ? name.slice(index + 1).toLowerCase() : '';
};

export const isImageFile = (file) => {
  const type = file?.type || '';
  if (ACCEPTED_CHAT_IMAGE_TYPES.includes(type) || type.startsWith('image/')) {
    return true;
  }
  return ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(getFileExtension(file?.name || ''));
};

export const attachmentPath = (url = '') => {
  try {
    return new URL(url, 'https://risman.local').pathname;
  } catch {
    return String(url).split('#')[0].split('?')[0];
  }
};

export const isImageAttachmentUrl = (url = '') => IMAGE_URL_EXT.test(attachmentPath(url));

export const attachmentDisplayName = (url = '', fallback = 'file') => {
  try {
    const parsed = new URL(url, 'https://risman.local');
    if (parsed.hash) {
      const named = decodeURIComponent(parsed.hash.slice(1)).trim();
      if (named) {
        return named.split(/[/\\]/).pop() || named;
      }
    }
    const fromPath = decodeURIComponent(parsed.pathname.split('/').pop() || '');
    return fromPath || fallback;
  } catch {
    return fallback;
  }
};

export const splitAttachmentUrls = (urls = []) => {
  const images = [];
  const files = [];
  for (const url of urls.filter(Boolean)) {
    if (isImageAttachmentUrl(url)) {
      images.push(url);
    } else {
      files.push(url);
    }
  }
  return { images, files };
};

export const toStoredAttachmentUrl = (item) => {
  if (!item?.url) {
    return '';
  }
  if (item.kind === 'image' || !item.name) {
    return item.url;
  }
  return `${item.url}#${encodeURIComponent(item.name)}`;
};

export const isAcceptedChatFile = (file) => {
  if (!file) {
    return false;
  }

  const type = file.type || '';
  if (ACCEPTED_CHAT_IMAGE_TYPES.includes(type)) {
    return true;
  }
  if (type.startsWith('text/')) {
    return true;
  }
  if (
    type === 'application/pdf' ||
    type === 'application/json' ||
    type === 'application/msword' ||
    type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    type === 'application/vnd.ms-excel' ||
    type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    type === 'application/vnd.ms-powerpoint' ||
    type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
    type === 'application/rtf'
  ) {
    return true;
  }

  return ACCEPTED_CHAT_FILE_EXTENSIONS.includes(getFileExtension(file.name || ''));
};
